// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1xPIy","title":"AfterBackImages_title__4wUMV","images":"AfterBackImages_images__PBYkL"};